import { IconContent } from '@icons';

export const arrowUpRight: IconContent = {
    sm: '<path d="M14 2v6h-1V3.707L8.207 8.5 7.5 7.793 12.293 3H8V2h6Z" /><path d="M5 4H2v10h10v-3h-1v2H3V5h2V4Z" />',
};
